import { client } from "./client";
import interceptors from "./interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getLetterHeader(params) {
	return client.get("api/letter/header", {
		params: params,
	});
}

export default {
	getLetterHeader,
}